<template>
    <div>
        <el-card shadow='never' class='box-card' style='margin-top: 2rem'>
            <div slot='header' class='clearfix'>
                <el-row :gutter='30'>
                    <el-col :span='5'>
                        <el-button :disabled='!showRetentionTableNumber' style='float: left; padding: 3px 0'
                                   @click='showRetentionTableNumber = false' type='text'>留存率
                        </el-button>
                        &nbsp;&nbsp;
                        <el-button :disabled='showRetentionTableNumber' style='float: left; padding: 3px 0'
                                   @click='showRetentionTableNumber = true' type='text'>留存数
                        </el-button>
                        &nbsp;&nbsp;
                        <el-button :disabled='!chartLoadingStatus.retentionLoadingStatus' style='float: left; padding: 3px 0'
                                   @click='getList()' type='text'>刷新</el-button>
                        &nbsp;&nbsp;
                        <el-button style='float: left; padding: 3px 0' @click='resetParam()' type='text'>重置</el-button>
                    </el-col>
                    <el-col :span='19'>
                        <el-select clearable multiple v-model='queryParams.eventIdList' filterable
                                   placeholder='请选择'>
                            <el-option
                                v-for='item in trackEventList'
                                :key='item.id'
                                :label='item.eventName'
                                :value='item.id'>
                            </el-option>
                        </el-select>
                        
                        &nbsp;&nbsp;
                        <el-date-picker
                            v-model='timePicker.pickerTimeValue'
                            type='datetimerange'
                            align='right'
                            unlink-panels
                            range-separator='至'
                            start-placeholder='开始日期'
                            end-placeholder='结束日期'
                            value-format='yyyy-MM-dd HH:mm:ss'
                            @blur='handleTimePickerBlur'
                            :picker-options='timePicker.pickerOptions'>
                        </el-date-picker>
                        
                        &nbsp;&nbsp;
                        <el-radio-group ref='timeUnitButGroup' @input='handleTimeUnitChange' v-model="queryParams.timeUnitType">
                            <el-radio-button label="DAY">天</el-radio-button>
                            <el-radio-button label="WEEK">周</el-radio-button>
                            <el-radio-button label="MONTH">月</el-radio-button>
                        </el-radio-group>
                        
                        &nbsp;&nbsp;
                        <el-button icon='el-icon-search' type='primary' @click='getList'>搜索</el-button>
                    </el-col>
                </el-row>
            </div>
            <el-skeleton :rows="7" :animated='true' :loading='skeletonLoading' :throttle='500'>
                <el-table
                    :data="retentionTableData.retentionDataTableList">
                    <el-table-column
                        prop="retentionStartTime"
                        label="时间">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="新增用户">
                        <template slot-scope='scope'>
                            <span>{{computeRetentionUserCount(scope.row)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        v-for='(item, index) in retentionTableData.tableColumnCount'
                        :key='index'
                        :label='computeColumnLabel(index)'>
                        <template slot-scope='scope'>
                            <span style='color: #409EFF;'>{{ computeRetentionUser(scope.row, index) }}</span>
                            &nbsp;&nbsp;<span style='color: #F56C6C'>{{ computeLostUser(scope.row, index) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop='name'
                        label='总和'>
                        <template slot-scope='scope'>
                            <span>{{ computeRetentionCountSum(scope.row) }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-skeleton>
        </el-card>
        
        <cotton-echarts :show-card-header='true'
                        :loading='chartLoadingStatus.retentionLoadingStatus'
                        :chart-option='showRetentionNumber ? chartOption.retentionUserNumberOption : chartOption.retentionUserProportionOption'>
            <template #echarts-header>
                <el-row :gutter='30'>
                    <el-col :span='12'>
                        <el-button :disabled='!showRetentionNumber' style='float: left; padding: 3px 0'
                                   @click='showRetentionNumber = false' type='text'>留存率
                        </el-button>
                        &nbsp;&nbsp;
                        <el-button :disabled='showRetentionNumber' style='float: left; padding: 3px 0'
                                   @click='showRetentionNumber = true' type='text'>留存数
                        </el-button>
                        &nbsp;&nbsp;
                        <el-button :disabled='!chartLoadingStatus.retentionLoadingStatus' style='float: left; padding: 3px 0'
                                   @click='getList()' type='text'>刷新</el-button>
                    </el-col>
                </el-row>
            </template>
        </cotton-echarts>
        
        <el-card shadow='never' class='box-card' style='margin-top: 2rem'>
            <div slot='header' class='clearfix'>
                <span>每日留存详细数据</span>
                <el-alert
                    style='margin-top: 1rem;'
                    title='下面展示的数据中，如果客户端标识(clientTag)前存在user_，则user_后面的值为我们系统中的玩家id'
                    type='success'
                    :closable='false'>
                </el-alert>
            </div>
            <el-collapse v-model='collapseActiveName' accordion>
                <el-collapse-item v-for='(value, key) in everyDayRetentionUserMap' :key='key'
                                  :title='computeCollapseTitle(value)'
                                  :name='computeCollapseUnique(value)'>
                    
                    <el-collapse @change='handleChangeCollapse' style='margin-left: 2rem;' v-model='collapseItemActiveName' accordion>
                        <el-collapse-item v-for='(itemValue, itemKey) in computeSingleRetention(value)' :key='key'
                                          :title='computeCollapseItemTitle(itemValue[1], itemKey)'
                                          :name='computeCollapseItemUnique(itemValue[1], value[0], itemKey)'>
                            <el-descriptions :column='1' :colon='false'>
                                <el-descriptions-item label='当日留存数'>
                                    <span style='color: #F56C6C'>{{ itemValue[1]['currentUserCount'] }}</span>
                                </el-descriptions-item>
                                <el-descriptions-item label='留存率'>
                                    <span style='color: #F56C6C'>{{ itemValue[1]['percentage'] }}</span>
                                </el-descriptions-item>
                                <el-descriptions-item :label='`${itemValue[0]} 日新用户数量 `'>
                                    <span style='color: #F56C6C'>{{ itemValue[1]['totalUserCount'] }}</span>
                                </el-descriptions-item>
                                <el-descriptions-item :label='`${itemValue[0]} 日留存用户客户端标识`'>
                                    <div>
                                        <ul class='new-user-client-tag'>
                                            <li v-for='(item, index) in singleTimeUnitUser.userList' :key='index'>
                                                <span>{{ item.retentionClientId }}</span>&nbsp;&nbsp;<el-tag size='mini'
                                                                                                        v-if='computeIsAccountUserId(item.retentionClientId)'>
                                                真实UserId
                                            </el-tag>
                                            </li>
                                        </ul>
                                        
                                        <el-pagination
                                            style='margin-bottom: 1rem;'
                                            :current-page='singleTimeUnitUser.queryParams.pageNum'
                                            :page-size='singleTimeUnitUser.queryParams.pageSize'
                                            :total='singleTimeUnitUser.queryParams.total'
                                            background
                                            layout='prev, pager, next'
                                            @current-change='handlePagination'>
                                        </el-pagination>
                                    </div>
                                </el-descriptions-item>
                            </el-descriptions>
                        </el-collapse-item>
                    </el-collapse>
                </el-collapse-item>
            </el-collapse>
        </el-card>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { trackAnalyseApi } from '@api/Track/trackAnalyse';
import { projectInfoApi } from '@api/ProjectInfo';
import bus from '@/components/common/bus';
import { message } from '@/utils/message';
import { trackEventApi } from '@api/Track/trackEvent';

export default defineComponent({
    name: 'TrackSummary',
    data() {
        return {
            queryParams: {
                projectAppId: undefined,
                eventId: undefined,
                eventIdList: undefined,
                startTime: undefined,
                endTime: undefined,
                timeUnitType: 'DAY'
            },
            projectInfo: {},
            retentionUserChartResult: {},
            retentionTableData: {
                retentionDataTableList: [],
                tableColumnCount: 0
            },
            skeletonLoading: true,
            chartLoadingStatus: {
                retentionLoadingStatus: false,
                retentionTableLoadingStatus: false,
            },
            showRetentionNumber: false,
            showRetentionTableNumber: false,
            chartOption: {
                showOptions: {},
                retentionUserProportionOption: {
                    title: {
                        text: ''
                    },
                    legend: {
                        type: 'scroll',
                        orient: 'vertical',
                        right: 10,
                        top: 20,
                        bottom: 20,
                        data: []
                    },
                    tooltip: {
                        trigger: 'axis',
                        formatter: (params, ticket, callback) => {
                            if (!params) {
                                return ''
                            }
                            let viewResult = `<p>${params[0].data[0]} 留存流失情况</p>`
                            params.forEach((item, index) => {
                                let marker = item.marker
                                let data = item.data
                                let newUserCount = data[5]
                                let retentionCount = data[4]
                                let churnedCount = newUserCount - retentionCount
                                let lineShow = "<p>" + marker + "&nbsp;" + `留存: <span style='color: #409EFF'>${retentionCount}</span> 留存率: <span style='color: #409EFF'>${data[1]}</span> 流失: <span style='color: #F56C6C'>${churnedCount}</span>` + "</p>"
                                viewResult = viewResult + lineShow
                            })
                            
                            return viewResult
                        }
                    },
                    toolbox: {
                        show: true,
                        feature: {
                            saveAsImage: {
                                show: true,
                                excludeComponents: ['toolbox'],
                                pixelRatio: 2
                            }
                            
                        }
                    },
                    dataset: [
                        {
                            source: [],
                            dimensions: ['dateTime', 'percentage', 'proportion', 'timestamp', 'currentUserCount', 'totalUserCount']
                        },
                        {
                            transform: {
                                type: 'sort',
                                config: { dimension: 'timestamp', order: 'asc' }
                            }
                        }
                    ],
                    dataZoom: [
                        {
                            type: 'inside',
                        }
                    ],
                    xAxis: {
                        type: 'category',
                        axisLabel: {
                            interval: 'auto',
                            rotate: 25,
                        },
                        name: '日期'
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            interval: 'auto',
                            formatter: '{value}'
                        },
                        name: '单日新增',
                        position: 'left'
                    },
                    series: []
                },
                retentionUserNumberOption: {
                    title: {
                        text: ''
                    },
                    legend: {
                        type: 'scroll',
                        orient: 'vertical',
                        right: 10,
                        top: 20,
                        bottom: 20,
                        data: [
                        
                        ]
                    },
                    tooltip: {
                        trigger: 'axis',
                        formatter: (params, ticket, callback) => {
                            if (!params) {
                                return ''
                            }
                            let viewResult = `<p>${params[0].data[0]} 留存流失情况</p>`
                            params.forEach((item, index) => {
                                let marker = item.marker
                                let data = item.data
                                let newUserCount = data[5]
                                let retentionCount = data[4]
                                let churnedCount = newUserCount - retentionCount
                                let lineShow = "<p>" + marker + "&nbsp;" + `留存: <span style='color: #409EFF'>${retentionCount}</span> 留存率: <span style='color: #409EFF'>${data[1]}</span> 流失: <span style='color: #F56C6C'>${churnedCount}</span>` + "</p>"
                                viewResult = viewResult + lineShow
                            })
                            
                            return viewResult
                        }
                    },
                    toolbox: {
                        show: true,
                        feature: {
                            saveAsImage: {
                                show: true,
                                excludeComponents: ['toolbox'],
                                pixelRatio: 2
                            }
                            
                        }
                    },
                    dataset: [
                        {
                            source: [],
                            dimensions: ['dateTime', 'percentage', 'proportion', 'timestamp', 'currentUserCount', 'totalUserCount']
                        },
                        {
                            transform: {
                                type: 'sort',
                                config: { dimension: 'timestamp', order: 'asc' }
                            }
                        }
                    ],
                    dataZoom: [
                        {
                            type: 'inside',
                        }
                    ],
                    xAxis: {
                        type: 'category',
                        axisLabel: {
                            interval: 'auto',
                            rotate: 25,
                        },
                        name: '日期'
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            interval: 'auto',
                            formatter: '{value}'
                        },
                        name: '单日新增',
                        position: 'left'
                    },
                    series: []
                },
            },
            singleTimeUnitUser: {
                queryParams: {
                    total: 0,
                    pageNum: 1,
                    pageSize: 15,
                    startTimeStr: undefined,
                    timeUnitType: undefined,
                    projectAppId: undefined,
                    retentionInitStartDateStr: undefined,
                    eventIdList: undefined
                },
                userList: []
            },
            everyDayRetentionUserMap: new Map,
            collapseActiveName: '',
            collapseItemActiveName: '',
            timePicker: {
                pickerTimeValue: [],
                pickerOptions: {
                    shortcuts: [
                        {
                            text: '最近一周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                picker.$emit('pick', [start, end]);
                            }
                        }, {
                            text: '最近一个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                picker.$emit('pick', [start, end]);
                            }
                        }, {
                            text: '最近三个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '最近五个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 150);
                                picker.$emit('pick', [start, end]);
                            }
                        }
                    ]
                }
            },
            trackEventList: []
        };
    },
    created() {
        this.setInitValue()
        if (this.queryParams.projectAppId) {
            bus.$emit('queriedTrackProjectAppId', this.queryParams.projectAppId)
        }
        if (this.queryParams.eventId) {
            bus.$emit('queriedTrackEventId', this.queryParams.eventId)
        }
        
        bus.$on('selectedTrackProjectAppId', this.handleSelectedTrackProjectAppIdEvent)
    },
    computed: {
        computeCollapseTitle() {
            return (value) => {
                let retentionData = value[1].retentionData
                let keys = Object.keys(retentionData)
                if (keys) {
                    let totalUserCount = retentionData[keys[0]]['totalUserCount']
                    return `${value[0]} 新增: ${totalUserCount}`
                }else {
                    return '未知'
                }
            };
        },
        computeCollapseUnique() {
            return (value) => {
                return `${value[0]}`;
            };
        },
        computeSingleRetention() {
            return (value) => {
                if (!value[1] || !value[1].retentionData) {
                    return new Map
                }
                let retentionData = value[1].retentionData
                let keys = Object.keys(retentionData)
                let map = new Map
                keys.forEach((k, v) => {
                    retentionData[k]['startTime'] = k
                    map.set(k, retentionData[k])
                })
                return map
            }
        },
        
        computeCollapseItemTitle() {
            return (value, key) => {
                let timeUnitStr = ''
                let timeUnit = this.$refs.timeUnitButGroup.value
                switch (timeUnit) {
                    case 'DAY':
                        timeUnitStr = '天'
                        break
                    case 'WEEK':
                        timeUnitStr = '周'
                        break
                    case 'MONTH':
                        timeUnitStr = '月'
                        break
                }
                return "+" + (key + 1) + timeUnitStr + "   \t留存率: " + value['percentage'];
            };
        },
        computeCollapseItemUnique() {
            return (value, parentTime, sonTime) => {
                return `${parentTime}|${value['startTime']}`
            };
        },
        computeIsAccountUserId() {
            return (clientTag) => {
                return clientTag.startsWith("user_");
                
            };
        },
        computeRetentionUserCount() {
            return (data) => {
                if (data.newUserTotal) {
                    return data.newUserTotal
                }else {
                    return '未知'
                }
            }
        },
        computeRetentionCountSum() {
            return (data) => {
                if (!data.retentionDetailList) {
                    return 0;
                }
                
                return data.retentionDetailList.reduce((sum, item) => {
                    // 手动判断防止 undefined
                    let count =
                        (item && item.retentionDetail && item.retentionDetail.currentUserCount)
                            ? item.retentionDetail.currentUserCount
                            : 0;
                    return sum + count;
                }, 0);
            };
        },
        computeRetentionUser() {
            return (retentionData, columnIndex) => {
                let retentionDetailList = retentionData.retentionDetailList
                let retentionIndexDetail = retentionDetailList[columnIndex]
                if (!retentionIndexDetail) {
                    return ''
                }
                let retentionDetail = retentionIndexDetail.retentionDetail
                if (!retentionDetail) {
                    return ''
                }
                if (this.showRetentionTableNumber) {
                    return retentionDetail.currentUserCount
                }
                return retentionDetail.percentage
            }
        },
        computeLostUser() {
            return (retentionData, columnIndex) => {
                let retentionDetailList = retentionData.retentionDetailList
                let retentionIndexDetail = retentionDetailList[columnIndex]
                if (!retentionIndexDetail) {
                    return ''
                }
                let retentionDetail = retentionIndexDetail.retentionDetail
                if (!retentionDetail) {
                    return ''
                }
                if (retentionDetail.reduceProportion !== 0) {
                    let descriptionOperator = "+"
                    if (retentionDetail.isReduceProportion) {
                        descriptionOperator = "-";
                    }
                    return descriptionOperator + retentionDetail.reducePercentage
                }
            }
        },
        computeColumnLabel() {
            return (index) => {
                let timeUnitStr = ''
                let timeUnit = this.$refs.timeUnitButGroup.value
                switch (timeUnit) {
                    case 'DAY':
                        timeUnitStr = '天'
                        break
                    case 'WEEK':
                        timeUnitStr = '周'
                        break
                    case 'MONTH':
                        timeUnitStr = '月'
                        break
                }
                return `+${index + 1}${timeUnitStr}`
            }
        }
    },
    methods: {
        resetParam() {
            this.queryParams = {
                projectAppId: this.queryParams.projectAppId,
                eventId: undefined,
                startTime: undefined,
                endTime: undefined,
                timeUnitType: 'DAY'
            }
            this.timePicker.pickerTimeValue = []
            this.getList()
        },
        reset() {
            this.chartLoadingStatus.retentionLoadingStatus = false
            this.chartLoadingStatus.retentionTableLoadingStatus = false
            this.skeletonLoading = true
            this.chartOption.retentionUserProportionOption.dataset = [
                {
                    source: [],
                    dimensions: ['dateTime', 'percentage', 'proportion', 'timestamp', 'clientTagList', 'totalUserCount', 'clientTagCount']
                },
                {
                    transform: {
                        type: 'sort',
                        config: { dimension: 'timestamp', order: 'asc' }
                    }
                }
            ]
            this.chartOption.retentionUserProportionOption.legend.data = []
            this.chartOption.retentionUserProportionOption.series = []
            
            this.chartOption.retentionUserNumberOption.dataset = [
                {
                    source: [],
                    dimensions: ['dateTime', 'percentage', 'proportion', 'timestamp', 'clientTagList', 'totalUserCount', 'clientTagCount']
                },
                {
                    transform: {
                        type: 'sort',
                        config: { dimension: 'timestamp', order: 'asc' }
                    }
                }
            ]
            this.chartOption.retentionUserNumberOption.legend.data = []
            this.chartOption.retentionUserNumberOption.series = []
            this.retentionTableData = {
                retentionDataTableList: [],
                tableColumnCount: 0
            }
        },
        getList() {
            this.reset()
            if (!this.queryParams.projectAppId || this.queryParams.projectAppId.indexOf('undefined') === 0) {
                message.error('请选择项目!')
                return
            }
            
            projectInfoApi.query({ appId: this.queryParams.projectAppId }).then(result => {
                if (result.code === 200) {
                    this.projectInfo = result.data.result[0];
                }
            });
            
            trackAnalyseApi.retention(this.queryParams).then(result => {
                if (result.code === 200) {
                    this.retentionUserChartResult = result.data
                    let data = result.data.addictionData
                    if (data) {
                        let timeKeySet = Object.keys(data)
                        timeKeySet.forEach((key, index) => {
                            let newClientTagList = []
                            if (data[key]['newClientTag']) {
                                newClientTagList = data[key]['newClientTag']
                            }
                            let newUserTotal = data[key]['newUserTotal']
                            let retentionData = {
                                retentionStartTime: key,
                                newClientTagList: newClientTagList,
                                retentionDetailList: [],
                                newUserTotal: newUserTotal
                            }
                            
                            let retentionDataMap = data[key]['retentionData']
                            let retentionDetailList = []
                            if (retentionDataMap) {
                                let retentionKeySet = Object.keys(retentionDataMap)
                                if (retentionKeySet.length === 0) {
                                    retentionData.retentionDetailList = retentionDetailList
                                    this.retentionTableData.retentionDataTableList.push(retentionData)
                                    if (index === timeKeySet.length - 1) {
                                        this.sortRetentionData()
                                    }
                                }else {
                                    retentionKeySet.forEach((retentionKey, retentionIndex) => {
                                        retentionDetailList.push({
                                            retentionStartTime: retentionKey,
                                            retentionDetail: retentionDataMap[retentionKey]
                                        })
                                        
                                        if (retentionIndex === retentionKeySet.length - 1) {
                                            retentionDetailList.sort((a, b) => {
                                                return new Date(a['retentionStartTime']) - new Date(b['retentionStartTime'])
                                            })
                                            retentionData.retentionDetailList = retentionDetailList
                                            this.retentionTableData.retentionDataTableList.push(retentionData)
                                            if (this.retentionTableData.tableColumnCount < retentionDetailList.length) {
                                                this.retentionTableData.tableColumnCount = retentionDetailList.length
                                            }
                                            if (index === timeKeySet.length - 1) {
                                                this.sortRetentionData()
                                            }
                                        }
                                    })
                                }
                            }else {
                                retentionData.retentionDetailList = retentionDetailList
                                this.retentionTableData.retentionDataTableList.push(retentionData)
                                if (index === timeKeySet.length - 1) {
                                    this.sortRetentionData()
                                }
                            }
                        })
                    }
                }else {
                    this.chartLoadingStatus.retentionTableLoadingStatus = true
                    this.skeletonLoading = false
                    this.chartLoadingStatus.retentionLoadingStatus = true
                }
            })
            
            trackEventApi.queryTrackEvent({projectAppId: this.queryParams.projectAppId, pageNum: 1, pageSize: 100000}).then(result => {
                if (result.code === 200) {
                    this.trackEventList = result.data.result
                }
            })
        },
        sortRetentionData() {
            this.retentionTableData.retentionDataTableList.sort((a, b) => {
                return new Date(a['retentionStartTime']) - new Date(b['retentionStartTime'])
            })
            this.chartLoadingStatus.retentionTableLoadingStatus = true
            this.skeletonLoading = false
            this.setRetentionUserOption()
        },
        setRetentionUserOption() {
            this.everyDayRetentionUserMap = new Map;
            this.chartOption.retentionUserProportionOption.title.text = '最近' + this.retentionUserChartResult.chartName + '留存率';
            if (!this.retentionUserChartResult.addictionData) {
                message.success('无新增用户数据!');
                return;
            }
            let addictionData = this.retentionUserChartResult.addictionData;
            const retentionUserKeys = Object.keys(addictionData);
            if (retentionUserKeys.length === 0) {
                this.handleEmptyData()
                return;
            }
            retentionUserKeys.forEach((key, index) => {
                this.everyDayRetentionUserMap.set(key, addictionData[key])
                let singleDataSet = {
                    dimensions: ['dateTime', 'percentage', 'proportion', 'timestamp', 'currentUserCount', 'totalUserCount'],
                    source: [],
                    customChartData: true,
                    startTime: key
                }
                // 获取newClientTag和retentionData
                let retentionDataList = addictionData[key].newClientTag
                let retentionData = addictionData[key].retentionData
                let retentionKeySet = Object.keys(retentionData)
                if (retentionKeySet.length > 0) {
                    retentionKeySet.forEach((retentionKey, retentionIndex) => {
                        // 获取每一个retentionDetail
                        let retentionDetailData = retentionData[retentionKey]
                        singleDataSet.source.push([retentionKey, retentionDetailData['percentage'], retentionDetailData['proportion'],
                            retentionDetailData['timestamp'], retentionDetailData['currentUserCount'], retentionDetailData['totalUserCount']])
                        if (retentionIndex === retentionKeySet.length - 1) {
                            this.chartOption.retentionUserProportionOption.dataset.push(singleDataSet)
                            this.chartOption.retentionUserNumberOption.dataset.push(singleDataSet)
                            
                            if (index === retentionUserKeys.length - 1) {
                                this.sortChartData()
                            }
                        }
                    })
                }else {
                    if (index === retentionUserKeys.length - 1) {
                        this.chartLoadingStatus.retentionLoadingStatus = true
                        this.sortChartData()
                    }
                }
            })
        },
        sortChartData() {
            this.chartOption.retentionUserProportionOption.dataset.forEach((source, index) => {
                if (!source.customChartData) {
                    return
                }
                this.chartOption.retentionUserProportionOption.series.push({
                    type: 'line',
                    name: source.startTime,
                    smooth: true,
                    encode: { x: 'dateTime', y: 'proportion' },
                    datasetIndex: index
                })
                this.chartOption.retentionUserProportionOption.legend.data.push({
                    name: source.startTime,
                    icon: 'circle'
                })
                
                // 留存数量
                this.chartOption.retentionUserNumberOption.series.push({
                    type: 'line',
                    name: source.startTime,
                    smooth: true,
                    encode: { x: 'dateTime', y: 'currentUserCount' },
                    datasetIndex: index
                })
                this.chartOption.retentionUserNumberOption.legend.data.push({
                    name: source.startTime,
                    icon: 'circle'
                })
                
                if (index === this.chartOption.retentionUserProportionOption.dataset.length - 1) {
                    this.chartLoadingStatus.retentionLoadingStatus = true
                }
            })
        },
        handleEmptyData() {
        
        },
        loadClientTagList() {
            this.count += 2;
        },
        handleTimePickerBlur() {
            if (this.timePicker.pickerTimeValue.length === 0) {
                return
            }
            this.queryParams.startTime = this.timePicker.pickerTimeValue[0] + " 00:00:00"
            this.queryParams.endTime = this.timePicker.pickerTimeValue[1] + " 23:59:59"
            this.getList()
        },
        handleSelectedTrackProjectAppIdEvent(t) {
            this.queryParams.projectAppId = t
            this.$router.push(`/trackAnalyse/newUser/${t}`)
            this.setInitValue()
        },
        setInitValue() {
            this.queryParams.projectAppId = undefined
            this.queryParams.eventId = undefined
            if (this.$route.params.eventId && this.$route.params.eventId.indexOf('undefined') === -1) {
                this.queryParams.eventId = this.$route.params.eventId
            }
            if (this.$route.params.projectAppId && this.$route.params.projectAppId.indexOf('undefined') === -1) {
                this.queryParams.projectAppId = this.$route.params.projectAppId
            }
            if (!this.queryParams.projectAppId) {
                message.error('请选择项目!')
                return
            }
            this.getList()
        },
        handleTimeUnitChange() {
            this.getList()
        },
        
        queryRetentionUserList() {
            if (!this.singleTimeUnitUser.queryParams.retentionInitStartDateStr || !this.singleTimeUnitUser.queryParams.startTimeStr) {
                return
            }
            this.singleTimeUnitUser.queryParams.eventIdList = this.queryParams.eventIdList
            trackAnalyseApi.queryRetentionUserByTimeInterval(this.singleTimeUnitUser.queryParams).then(result => {
                if (result.code === 200) {
                    this.singleTimeUnitUser.queryParams.total = result.data.total
                    this.singleTimeUnitUser.queryParams.pageNum = result.data.pageNum
                    this.singleTimeUnitUser.queryParams.pageSize = result.data.pageSize
                    this.singleTimeUnitUser.userList = result.data.result
                }
            })
        },
        handleChangeCollapse(parentAndSonTime) {
            let timeArr = parentAndSonTime.split("|")
            let parentStartTime = timeArr[0]
            let sonStartTime = timeArr[1]
            this.singleTimeUnitUser.queryParams.retentionInitStartDateStr = parentStartTime
            this.singleTimeUnitUser.queryParams.timeUnitType = this.queryParams.timeUnitType
            this.singleTimeUnitUser.queryParams.startTimeStr = sonStartTime
            this.singleTimeUnitUser.queryParams.projectAppId = this.queryParams.projectAppId
            this.singleTimeUnitUser.queryParams.pageNum = 1
            this.queryRetentionUserList()
        },
        handlePagination(pageNum) {
            this.singleTimeUnitUser.queryParams.pageNum = pageNum;
            this.queryRetentionUserList()
        },
    }
});
</script>

<style scoped lang='css'>
.new-user-client-tag {
    max-height: 20rem;
    overflow-y: scroll;
}

.new-user-client-tag li {
    margin-top: .5rem;
}
</style>